import { FC, ReactNode } from 'react';

import styles from './styles.less';

const VerticallyCentredIconSize16: FC<{ icon: ReactNode }> = ({ icon }) => {
    return (
        <span className={styles.wrapper}>
            <span className={styles.icon}>{icon}</span>
        </span>
    );
};

export default VerticallyCentredIconSize16;
